/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useEffect, useRef } from "react";
import { upsertQueryParam } from "common/utils/browser";
import Tile from "./Tile.vue";
import { useDtfStore } from "../store";
import "./Variants.scss";
import { renderList } from "common/vue/render-list";
import { cn } from "tailwind-variants";

export default function Variants(props: any) {
  const { ...restProps } = props;
  const dtfStore = useDtfStore();

  function gangSheetBuilderVariants() {
    // @ts-expect-error TS(4111): Property 'gangSheetBuilderVariants' comes from an ... Remove this comment to see the full error message
    return dtfStore.gangSheetBuilderVariants;
  }

  function gangSheetBuilderSettings() {
    // @ts-expect-error TS(4111): Property 'gangSheetBuilderSettings' comes from an ... Remove this comment to see the full error message
    return dtfStore.gangSheetBuilderSettings;
  }

  function updateGangSheetBuilderSettings(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.updateGangSheetBuilderSettings(...args);
  }

  function setProductSlug(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.setProductSlug(...args);
  }

  function setVariantId(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.setVariantId(...args);
  }

  function updatePdpDates(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.updatePdpDates(...args);
  }

  function updateBulkTable(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.updateBulkTable(...args);
  }

  function updateCarouselImage(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.updateCarouselImage(...args);
  }

  function handleTileSelected(value: any) {
    // @ts-expect-error TS(2769): No overload matches this call.
    const variantObj = Object.values(gangSheetBuilderVariants()).find(
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      variant => variant.variant_id === value
    );
    setVariantId(value);
    updateGangSheetBuilderSettings({
      variantId: value
    });
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    setProductSlug(variantObj.product_slug);
    updatePdpDates();
    updateBulkTable();
    updateCarouselImage({
      variantId: value
    });
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    upsertQueryParam("v", variantObj.catalog_number, {
      redirect: false,
      replace: false
    });
  }

  function isSelected(variantId: any) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return gangSheetBuilderSettings().variantId === variantId;
  }

  const gangSheetBuilderSettingsRef = useRef(gangSheetBuilderSettings);
  gangSheetBuilderSettingsRef.current = gangSheetBuilderSettings;

  useEffect(() => {
    updateCarouselImage({
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      variantId: gangSheetBuilderSettingsRef.current().variantId
    });
  }, []);

  return (
    <div {...restProps} className={cn("gang-sheet-builder-variants")}>
      <span className={cn("gang-sheet-builder-variants__title")}>Select variant</span>
      <div className={cn("gang-sheet-builder-variants__tiles")}>
        {renderList(gangSheetBuilderVariants(), (variant, label) => (
          <Tile
            key={variant.variant_id}
            value={{
              label,
              value: variant.variant_id
            }}
            isSelected={isSelected(variant.variant_id)}
            onTileSelected={handleTileSelected}
            data-testid="tile"
          />
        ))}
      </div>
    </div>
  );
}
